import { Container } from "react-bootstrap";
import "./panel.scss";

const Panel = ({children, id="", className=""}) => {

    return (
        <Container id={id} className={"panel d-flex flex-column align-items-center overflow-y-auto "+className}>
            {children}
        </Container>
    );
}

export default Panel;